import { render, staticRenderFns } from "./editPurchaseApply.vue?vue&type=template&id=19c1ebbc"
import script from "./editPurchaseApply.vue?vue&type=script&lang=js"
export * from "./editPurchaseApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports